import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { Button } from '../ui/Button';
export function Transformacion() {
  const antes = ['No podés dormir porque se te sube el ácido', 'Todo lo que comés te pone mal — hasta el agua', 'El omeprazol ya no alcanza como antes', 'Flema, tos crónica, atoro en la garganta todo el día', 'Dolor en el estómago, el pecho y la espalda', 'Probaste vinagre, bicarbonato, sábila... y seguís igual'];
  const despues = ['Dormís toda la noche sin que el ácido te despierte', 'Sabés exactamente qué te hace daño y por qué', 'Descansando de medicamentos de farmacia', 'Comés con tranquilidad — adiós al ardor constante', 'Ya no tenés esa molestia en la garganta', 'Tenés un protocolo de emergencia para los días difíciles'];
  return <section id="transformacion" className="py-[100px] bg-gradient-to-b from-[#1a0f08] to-[#120806]" data-id="element-364">
      <div className="container-custom" data-id="element-365">
        <SectionHeader eyebrow="La transformación" title={<>
              Tu vida <span className="text-gold" data-id="element-367">antes y después</span>
              <br data-id="element-368" />
              del Protocolo de Reprogramación Digestiva™
            </>} data-id="element-366" />

        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-6 items-stretch max-w-[900px] mx-auto mt-[60px]" data-id="element-369">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#120500]/60 border border-red-soft/20 rounded-[12px] p-[36px_28px]" data-id="element-370">
            <div className="text-[11px] tracking-[2px] uppercase mb-6 flex items-center gap-2 text-[#e07070] font-semibold" data-id="element-371">
              ✗ &nbsp;Sin el protocolo
            </div>
            <div className="flex flex-col gap-3.5" data-id="element-372">
              {antes.map((item, i) => <div key={i} className="flex gap-2.5 items-start text-[14px] leading-[1.5] text-[#c8a0a0]" data-id="element-373">
                  <div className="w-4 h-4 rounded-full shrink-0 mt-0.5 flex items-center justify-center text-[10px] bg-red-soft/20 text-[#e07070]" data-id="element-374">
                    ✗
                  </div>
                  <span data-id="element-375">{item}</span>
                </div>)}
            </div>
          </motion.div>

          <div className="flex items-center justify-center py-4 md:py-0" data-id="element-376">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gold to-gold-light text-deep font-black text-[14px] flex items-center justify-center shadow-[0_0_30px_rgba(200,150,62,0.4)]" data-id="element-377">
              VS
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-[#001208]/60 border border-green-soft/30 rounded-[12px] p-[36px_28px]" data-id="element-378">
            <div className="text-[11px] tracking-[2px] uppercase mb-6 flex items-center gap-2 text-[#6fcca0] font-semibold" data-id="element-379">
              ✓ &nbsp;Con el Protocolo
            </div>
            <div className="flex flex-col gap-3.5" data-id="element-380">
              {despues.map((item, i) => <div key={i} className="flex gap-2.5 items-start text-[14px] leading-[1.5] text-[#a0c8b0]" data-id="element-381">
                  <div className="w-4 h-4 rounded-full shrink-0 mt-0.5 flex items-center justify-center text-[10px] bg-green-soft/20 text-[#6fcca0]" data-id="element-382">
                    ✓
                  </div>
                  <span data-id="element-383">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center" data-id="element-384">
          <p className="text-[17px] text-white font-semibold mb-4" data-id="element-385">
            Pasá del lado izquierdo al derecho en 72 horas.
          </p>
          <Button href="#oferta" variant="primary" fullWidth={false} data-id="element-386">
            QUIERO EMPEZAR HOY →
          </Button>
        </motion.div>
      </div>
    </section>;
}